export var ConstantEnum = {
    /**
     * web-tools redux localStorage key
     */
    WEMEET_WEB_TOOLS_KEY: 'persist:root',
    /**
     * web-base localStorage key
     */
    WEMEET_STORAGE_KEY: 'tencent-meeting-web-redux-store',
    /**
     * 灯塔
     */
    WEMEET_BEACON_DEBUG_KEY: 'LOGDEBUGKEY00254',
    WEMEET_BEACON_PROD_KEY: '00000C2AM539PVHX',
    /**
     * 开启灯塔实时联调
     */
    WEMEET_BEACON_OPEN_DEBUG: 'debugBeacon',
    /**
     * 防水墙appid
     */
    CAPTCHA_APP_ID: '2099486352',
    /**
     * VooV 防水墙appid
     */
    VOOV_CAPTCHA_APP_ID: '188904464',
};
